import React from "react";
import { useDispatch } from "../../store";
import {
  logBrowseGroupExpanded,
  logBrowseTopicClicked,
} from "../../util/analytics";
import BrowseAccordion from "../../components/BrowseAccordion";
import { PageDescription, PageTitle } from "../../components";
import { getTopicViewModel } from "../../store/browse/actions";

export const formatLabel = (label) =>
  label.toLowerCase().replace(/[\s/]/g, "_");

const AccordionTemplate = ({
  browsePath,
  options = {},
  title,
  description,
  cdh,
  cdhTopics,
  excludedContent,
}) => {
  const dispatch = useDispatch();

  const columns = options.columns || 1;
  const isOpenDefault = options.isOpenDefault || false;
  const lazyLoad = options.lazyLoad || false;

  const onAccordionClick = (label, isOpen) => {
    const viewModel = cdhTopics?.[label];

    // log amplitude event
    if (!isOpen && lazyLoad && !viewModel) {
      getTopicViewModel(dispatch, browsePath, { category: label });
    }
    if (!isOpen) {
      logBrowseGroupExpanded({
        categoryId: formatLabel(label),
        browseType: title,
      });
    }
  };

  const onTopicClick = (label, slug) => {
    // log amplitude event
    logBrowseTopicClicked({
      categoryId: formatLabel(label),
      topicId: slug,
      browseType: title,
    });
  };

  return (
    <>
      <PageTitle>{title}</PageTitle>
      <PageDescription>{description}</PageDescription>
      <div>
        {cdh &&
          cdh.map(({ label }) => (
            <BrowseAccordion
              key={label}
              label={label}
              topics={cdhTopics?.[label]}
              columns={columns}
              isOpenDefault={isOpenDefault}
              onAccordionClick={onAccordionClick}
              onTopicClick={onTopicClick}
              excludedContent={excludedContent}
            />
          ))}
      </div>
    </>
  );
};

export default AccordionTemplate;
